<mat-card *ngIf="reservation && reservationMasterContact"
  class="singleDetailsCard animate__animated animate__slideInLeft animate__faster">
  <div class="singleDetailsToolbar">
      <div class="toolbar-content">
          <div class="toolbar-section name-section">
              <label *ngIf="!!reservationMasterContact?.first_name || !!reservationMasterContact?.last_name"
                     class="singleDetailsName color-base-6">
                  {{ (reservationMasterContact?.first_name || '') + ' ' + (reservationMasterContact?.last_name || '') }}
              </label>
              <label *ngIf="!reservationMasterContact?.first_name && !reservationMasterContact?.last_name"
                     class="singleDetailsName color-base-6">
                  {{ 'No Name' }}
              </label>
          </div>
          <div class="toolbar-section status-section">
              <img *ngIf="reservation.state === 'completed'" alt="completed"
                   class="statusImagesIconReservation" src="assets/icons/status/completed.png"/>
              <img *ngIf="reservation.state === 'confirmed'" alt="confirmed"
                   class="statusImagesIconReservation" src="assets/icons/status/confirmed.png"/>
              <img *ngIf="reservation.state === 'draft'" alt="draft"
                   class="statusImagesIconReservation" src="assets/icons/status/draft.png"/>
              <img *ngIf="reservation.state === 'waiting'" alt="waiting"
                   class="statusImagesIconReservation" src="assets/icons/status/waiting.png"/>
              <img *ngIf="reservation.state === 'revoked'" alt="revoked"
                   class="statusImagesIconReservation" src="assets/icons/status/revoked.png"/>
              <img *ngIf="reservation.state === 'rejected'" alt="rejected"
                   class="statusImagesIconReservation" src="assets/icons/status/rejected.png"/>
              <!-- <label class="singleDetailsStatus color-base-6">{{ capitalize(reservation.state || '') | translate
                  }}</label> -->
              <ws-chip
                [label]="statusFn(reservation) | translate"
                [type]="statusBgColorFn(reservation)"
                ></ws-chip>
          </div>
          <div class="toolbar-section actions-section">
              <ws-button (click)="onClickDetail(reservation)" [callToActionType]="'link'" class="colorLink">{{ 'Open for
                  more details' |
                  translate}}
              </ws-button>
              <div *ngIf="reservation.giftId" class="gift">
                  gift <i class="icon-gift-box-open"></i>
              </div>
          </div>
          <div class="toolbar-section icons-section">
              <mat-icon [ngClass]="{'green': isPaid(reservation)}">payments</mat-icon>
              <mat-icon [ngClass]="{'green': isSales(reservation)}">receipt_long</mat-icon>
              <mat-icon [ngClass]="{'green': isCheckedIn(reservation)}">location_on</mat-icon>
          </div>
      </div>
  </div>
  <div class="singleDetailsContent">
      <div class="content-columns">
          <!-- COLUMN 1: Contact Information -->
          <div class="content-column contact-column">
              <div class="field-wrapperlt">
                  <mat-icon class="matIconForLabel">alternate_email</mat-icon>
                  <label [title]="reservationMasterContact?.email"
                         class="wrapperltLabelforValue wrapperltLabelforValueXSmall maxWidthForEmail">{{reservationMasterContact?.email}}</label>
              </div>
              <div *ngIf="reservationMasterContact?.phone_number && reservationMasterContact?.phone_number !== 'null'" class="field-wrapperlt">
                  <mat-icon class="matIconForLabel">phone_in_talk</mat-icon>
                  <label
                          class="wrapperltLabelforValue wrapperltLabelforValueSmall">{{reservationMasterContact?.phone_number}}</label>
              </div>
              <div *ngIf="!!!!reservationMasterContact?.country_iso" class="field-wrapperlt">
                  <mat-icon class="matIconForLabel">location_on</mat-icon>
                  <label *ngIf="!!!!reservationMasterContact?.country_iso"
                         class="wrapperltLabelforValue wrapperltLabelforValueSmall">{{reservationMasterContact?.country_iso!
                      | translate}}</label>
                  <ws-flag [countryCode]="reservationMasterContact?.country_iso" [showBorder]="true"
                           size="small"></ws-flag>
              </div>
              <div class="multiline">
                  <div class="field-wrapperlt">
                      <mat-icon class="matIconForLabel">schedule</mat-icon>
                      <label class="wrapperltLabelforLabel">{{ 'Reservation timestamp' | translate }}:</label>
                  </div>
                  <div class="multilineRight">
            <span
                    class="wrapperltLabelforValue">{{ getReservationCreatedAtLabel() }}</span>
                  </div>
              </div>
          </div>

          <!-- COLUMN 2: Reservation Information (Scrollable) -->
          <div class="content-column reservation-column scrollable-column">
              <div class="field-wrapperlt">
                  <img alt="conversion" class="imageIconForLabel" src="assets/icons/icon-price-e-filled.png"/>
                  <label class="wrapperltLabelforLabel">{{
                      (reservation
                      ? getLabel1Title(reservation)
                      : ('Price 1' | translate))
                      | truncate:[20, '...']
                      }}: </label>
                  <span class="wrapperltLabelforValue">{{reservation?.guestCount01}}</span>
              </div>
              <ng-container *ngFor="let priceLabel of reservationPriceLabelsExcludeFirstIfPresent">
                  <div *ngIf="priceLabel.quantity > 0" class="field-wrapperlt">
                      <img alt="conversion" class="imageIconForLabel" src="assets/icons/icon-price-e-filled.png"/>
                      <label class="wrapperltLabelforLabel"> {{
                          (priceLabel?.title_translations?.it | truncate:[20, '...'])
                          }}: </label>
                      <label class="wrapperltLabelforValue">{{priceLabel.quantity}}</label>
                  </div>
              </ng-container>
              <ng-container *ngFor="let priceExtra of reservation?.reservationPriceExtras">
                  <div *ngIf="priceExtra.quantity > 0" class="field-wrapperlt">
                      <img alt="conversion" class="imageIconForLabel" src="assets/icons/icon-price-e.png"/>
                      <label class="wrapperltLabelforLabel"> {{
                          (priceExtra?.title_translations?.it | truncate:[20, '...'])
                          }}: </label>
                      <label class="wrapperltLabelforValue">{{priceExtra.quantity}}</label>
                  </div>
              </ng-container>
          </div>

          <!-- COLUMN 3: Additional Information -->
          <div class="content-column additional-column">
              <div *ngIf="reservation?.isTourOperator" class="field-wrapperlt">
                  <mat-icon class="matIconForLabel">location_on</mat-icon>
                  <label class="wrapperltLabelforLabel">{{'Origin' | translate}}: </label>
                  <label class="wrapperltLabelforValue wrapperltLabelforValueXSmall">
                      {{ 'Tour Operator' | translate }}
                  </label>
              </div>
              <div *ngIf="reservation?.origin && !reservation?.isTourOperator" class="field-wrapperlt">
                  <mat-icon class="matIconForLabel">location_on</mat-icon>
                  <label class="wrapperltLabelforLabel">{{'Origin' | translate}}: </label>
                  <label class="wrapperltLabelforValue wrapperltLabelforValueXSmall">
                      {{ getOrigin(reservation.origin) }}
                  </label>
              </div>
              <div *ngIf="!reservation.origin && !reservation?.isTourOperator" class="field-wrapperlt">
                  <mat-icon class="matIconForLabel">location_on</mat-icon>
                  <label class="wrapperltLabelforLabel">{{'Origin' | translate}}: </label>
                  <label class="wrapperltLabelforValue wrapperltLabelforValueXSmall">{{'Manual Reservation' |
                      translate}}</label>
              </div>
              <div *ngIf="multiLanguage" class="field-wrapperlt">
                  <mat-icon class="matIconForLabel">language</mat-icon>
                  <label class="wrapperltLabelforLabel">{{'Language' | translate}}: </label>
                  <ws-flag *ngIf="reservation.languageIso"
                           [countryCode]="getCountryCodeForLanguage(reservation.languageIso)" [showBorder]="true"
                           size="small">
                  </ws-flag>
                  <label class="wrapperltLabelforValue wrapperltLabelforValueXSmall">{{
                      reservation.languageIso
                      ? ('lang_' + reservation.languageIso | translate)
                      : ''
                      }}</label>
              </div>
              <div *ngIf="reservation.roomId" class="field-wrapperlt">
                  <mat-icon class="matIconForLabel">sensor_door</mat-icon>
                  <label class="wrapperltLabelforLabel">{{'Room' | translate}}: </label>
                  <label class="wrapperltLabelforValue wrapperltLabelforValueXSmall">{{roomName(reservation.roomId) |
                      truncate:[30,
                      '...']}}</label>
              </div>
              <div *ngIf="reservation.employeeId" class="field-wrapperlt">
                  <mat-icon class="matIconForLabel">person</mat-icon>
                  <label class="wrapperltLabelforLabel">{{'Employee' | translate}}: </label>
                  <label class="wrapperltLabelforValue wrapperltLabelforValueXSmall">{{employeeName(reservation.employeeId)
                      |
                      truncate:[30, '...']}}</label>
              </div>
              <div class="field-wrapperlt">
                  <mat-icon class="matIconForLabel">euro</mat-icon>
                  <label class="wrapperltLabelforLabel">{{'Total' | translate}}: </label>
                  <label class="wrapperltLabelforValue">{{formatTotal(reservation.netTotalCents || 0)}}</label>
              </div>
          </div>

          <!-- COLUMN 4: Messages -->
          <div class="content-column messages-column">
              <label class="wrapperltLabelforLabel">{{'Message of Customer' | translate}}: </label>
              <div class="textAreaLT">{{reservation.message}}</div>
              <label class="wrapperltLabelforLabel">{{'Internal Note' | translate}}: </label>
              <div class="textAreaLT">{{reservation.notes}}</div>
          </div>
      </div>
  </div>
</mat-card>